export default __webpack_public_path__ + "static/media/work-image-file@2x.054933de.svg";